import React, { Component } from 'react'
import {Toast} from 'antd-mobile';
import tools from '@/utils/tool';
import API from './../../config/api';
import httpRequest from '@/utils/httpRequest'
import './index.scss'
import Header from '@/components/Header/header'
import AppBtn from '@/components/AppBtn/appBtn'

// 基地活动和所站活动
export default class index extends Component {
  constructor(props){
    super(props)
    this.state = {
      uuid:'',
      data:{
        team:[]
      },
    }
  }

  componentDidMount(){
    let url = window.location.href
    let parameter =  tools.getParams(url)
    this.setState({
      type:parameter.type,
      uuid:parameter.uuid
    },() => {
      this.getList()
    })
  }

  getList = () => {
    const {uuid} = this.state
    httpRequest({
      url: API.stationTeamDetail,
      type: 'get',
      data: {
        uuid:uuid
      }
    }).done((resp) => {
      if (resp.code === 0) {
        this.setState({
          data:resp.data
        })
      } else {
        Toast.fail(resp.msg || resp.error);
      }
    }).fail(jqXHR => {
      Toast.fail(jqXHR.msg || jqXHR.error);
    })
  }

  render() {
    const {data} = this.state
    return (
      <div>
        {/*头部*/}
			  <Header name={'home'} uuid={''}/>
        <div className='teamDetailContainer'>
          <div className="cover"><img src={data.cover} alt=""/></div>
          <div className="title">{data.title}</div>
          {data.service_content?
            <div className="module">
              <div className="moduleTitle">服务内容：</div>
              <div className="content">{data.service_content}</div>
            </div>
          :''}
          {data.service_range?
            <div className="module">
              <div className="moduleTitle">服务范围：</div>
              <div className="content">{data.service_range}</div>
            </div>
          :''}
          {data.charge_user?
            <div className="module flexModule">
              <div className="moduleTitle">负责人：</div>
              <div className="content">{data.charge_user}</div>
            </div>
          :''}
          {data.mobile?
            <div className="module flexModule">
              <div className="moduleTitle ">联系电话：</div>
              <div className="content">{data.mobile}</div>
            </div>
          :''}
          {data.team.length > 0 ?
            <div className="module">
              <div className="moduleTitle">团队人员：</div>
              <div className="userContainer">
                {data.team.map((item,index) => {
                  return <div className="userItem" key={index}>
                            <div className="avatar"><img src={item.user_avatar} alt=""/></div>
                            <div className="name">{item.user_name}</div>
                          </div>
                })}
              </div>
            </div>
          :''}
          <AppBtn name={'home'} uuid={''} text={`申请加入`}/>
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/pages/CivilizationTeamDetail/index.js